/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseInstance} from './base-instance';
import {Antenna} from './antenna';
import {ZoneInstance} from './zone-instance';
import {ReaderInstance} from './reader-instance';
import {LocationInstance} from './location-instance';
import {Point} from './point';

export class AntennaInstance extends BaseInstance {
  antenna: Antenna;
  readZoneInstance: ZoneInstance;
  readerInstance: ReaderInstance;
  locationInstance: LocationInstance;
  port: number;
  powerLevel: number;
  position: Point;
  status: string;
}
